import { TITLE_FONT } from '../text.utils'
import type { TicketElement } from '../TicketElement'

export class Section implements TicketElement {
  text: string
  paddingTop: number
  paddingBottom: number
  boxHeight: number

  constructor(text: string) {
    this.text = text
    this.paddingTop = 16
    this.paddingBottom = 16
    this.boxHeight = 48
  }

  height(): number {
    return this.paddingTop + this.boxHeight + this.paddingBottom
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    top += this.paddingTop
    ctx.fillStyle = 'black'
    ctx.fillRect(0, top, width, this.boxHeight)
    ctx.font = `bold 20px ${TITLE_FONT}`
    ctx.fillStyle = 'white'
    ctx.textAlign = 'left'
    ctx.textBaseline = 'alphabetic'

    // Position text vertically centered
    const metrics = ctx.measureText(this.text)
    const textHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
    const y = top + this.boxHeight / 2 + textHeight / 2 - metrics.actualBoundingBoxDescent

    ctx.fillText(this.text, 15, y)
  }
}
